import * as Popover from "@radix-ui/react-popover"
import * as Tooltip from "@radix-ui/react-tooltip"
import { VesselDetails } from "@sop/MapPage/VesselsContentNL"
import { usePageLayoutContext } from "@ui-lib/index"
import { DetailedHTMLProps, FC, Fragment, HTMLAttributes, ReactNode, useState } from "react"
import { MdMoreVert } from "react-icons/md"

interface SecondaryNavItemProps
	extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	isSelected: boolean
	isDisabled?: boolean
	label: string
	icons?: ReactNode[]
	onDetailsClick?: (vessel: string) => void
}

export const SecondaryNavItem: FC<SecondaryNavItemProps> = (props: SecondaryNavItemProps) => {
	const { label, isSelected, isDisabled, icons, onDetailsClick, ...rest } = props
	const [openTooltip, setOpenTooltip] = useState<boolean>(false)
	const [openPopover, setOpenPopover] = useState<boolean>(false)

	const [clickOutsidePending, setClickOutsidePending] = useState(false)
	const { translationFunc } = usePageLayoutContext()
	const handleClose = () => {
		setOpenPopover(false)
	}
	return (
		<div
			onMouseDown={(e) => {
				if (isDisabled === true) {
					return
				}
				const elem = document.activeElement as HTMLElement | null
				elem?.blur?.()
				e.preventDefault()
				props.onClick
			}}
			id={`secondary-nav-item_${label.replaceAll(" ", "_")}`}
			className={`focus-style text-button relative flex h-8 w-full flex-row items-center justify-between overflow-x-clip rounded-sm pl-2 text-left font-semibold whitespace-nowrap ring-inset ${
				isSelected === true
					? `text-dipai-primary-501/100 cursor-default bg-white/10`
					: isDisabled === true
						? `cursor-default text-white/30`
						: `cursor-pointer text-white/60 group-hover:text-white/100 hover:bg-black/20 hover:text-white`
			}`}
			{...rest}
		>
			{isDisabled === true ? (
				<Tooltip.Provider>
					<Tooltip.Root
						delayDuration={50}
						open={openTooltip}
					>
						<Tooltip.Trigger
							// asChild
							onClick={(e) => {
								e.stopPropagation()
								if (!clickOutsidePending) {
									setOpenTooltip(!openTooltip)
								}
								setClickOutsidePending(false)
							}}
							onMouseEnter={() => {
								// hovering = true
								setTimeout(() => {
									// if (hovering) {
									setOpenTooltip(true)
									// }
								}, 200)
							}}
							onMouseLeave={() => {
								// hovering = false
								setTimeout(() => {
									setOpenTooltip(false)
								}, 200)
							}}
						>
							<p className={`cursor-help`}>{label} </p>
						</Tooltip.Trigger>
						<Tooltip.Portal>
							<Tooltip.Content
								className={`bg-dipai-secondary-800/85 z-10001 h-auto w-auto rounded-sm px-2 py-1 text-white/100`}
								sideOffset={5}
								side={`right`}
								onPointerDownOutside={(e) => {
									setOpenTooltip(false)
									setClickOutsidePending(true)
								}}
								onEscapeKeyDown={() => setOpenTooltip(false)}
							>
								<p>
									{translationFunc !== undefined
										? translationFunc(
												`THIS MODULE IS NOT AVAILABLE FOR THIS VESSEL`
											)
										: `This module is not available for this vessel`}
								</p>
								<Tooltip.Arrow className={`fill-dipai-secondary-800/85`} />
							</Tooltip.Content>
						</Tooltip.Portal>
					</Tooltip.Root>
				</Tooltip.Provider>
			) : (
				label
			)}

			{icons !== undefined ? (
				<div
					className={`flex flex-row justify-end gap-0`}
					onClick={(e) => e.stopPropagation()}
				>
					{icons.length > 0 && icons[0] !== null
						? icons.map((icon, index) => (
								<Fragment key={`icon_${index}`}>{icon}</Fragment>
							))
						: null}{" "}
					<Popover.Root open={openPopover}>
						<Popover.Trigger
							id={`popover-trigger_${label.replaceAll(" ", "_")}`}
							className="focus:ring-0 focus:outline-none"
							onClick={() => {
								onDetailsClick?.(label)
								setOpenPopover(!openPopover)
							}}
						>
							<MdMoreVert className={`h-5 w-5 hover:scale-120`} />
						</Popover.Trigger>
						<Popover.Portal>
							<Popover.Content
								className={`shadow-modal z-10001 mt-15.5 h-auto max-h-[calc(100vh-72px)] w-100 overflow-clip rounded-sm border-3 border-white bg-white focus:ring-0 focus:outline-none`}
								sideOffset={0}
								side={`right`}
								onPointerDownOutside={(e) => {
									const trigger = document.querySelector(
										`#popover-trigger_${label.replaceAll(" ", "_")}`
									)
									if (trigger?.contains(e.target as Node) === true) {
										e.preventDefault()
									} else {
										setOpenPopover(false)
									}
								}}
								onEscapeKeyDown={() => setOpenPopover(false)}
							>
								<VesselDetails
									vessel={label}
									handleClose={handleClose}
								/>
								<Popover.Arrow
									className="fill-white"
									width={15}
									height={7.5}
								/>
							</Popover.Content>
						</Popover.Portal>
					</Popover.Root>
				</div>
			) : null}
		</div>
	)
}
